"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubdomain = exports.SubdomainRegExp = exports.Subdomain = void 0;
const validation_1 = require("../validator/validation");
function normalize(subdomain) {
    return subdomain.toLowerCase();
}
function equals(a, b) {
    return normalize(a) === normalize(b);
}
exports.Subdomain = {
    normalize,
    equals,
};
exports.SubdomainRegExp = /^[a-z][-a-z0-9]{1,61}[a-z0-9]$/;
function matchesSubdomain(value) {
    return exports.SubdomainRegExp.test(value);
}
exports.isSubdomain = validation_1.isString.which((0, validation_1.satisfiesPredicate)(matchesSubdomain));
//# sourceMappingURL=subdomain.js.map